




































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Mutation, State } from 'vuex-class'
import FileUpload from '../StepsFive/FileUpload.vue'

@Component({
  components: { FileUpload },
})
export default class BusinessKefu extends Vue {
  @Prop({ required: true, type: Object }) form!: any
  @State bidType!: number
  @State kefuChannel!: number

  modalVisible = false
  start_work_time: string = ''
  end_work_time: string = ''

  get rules() {
    return {
      special_approval: [
        {
          required: true,
          message: '请上传特批证明照片',
        },
      ],
    }
  }

  get antForm() {
    return this.$refs.form
  }

  created() {
    if (!!this.form.cus_work_time) {
      this.start_work_time = this.form.cus_work_time.split('-')[0]
      this.end_work_time = this.form.cus_work_time.split('-')[1]
    }
  }

  handleChangeStart(value: string) {
    this.form.cus_work_time = value + '-' + this.end_work_time
  }
  handleChangeEnd(value: string) {
    this.form.cus_work_time = this.start_work_time + '-' + value
  }
}
